import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { getToken } from '../../store/auth';
import { callApi } from '../../helpers/methods' 

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Select } from '../inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';
import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_ADMINISTRADOR, ROLE_FEATURE_1, ROLE_FEATURE_3 } from '../../store/roles';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

class EnvioToi extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            mailing: { id: 0 },
            file: null,
            comboEmpresa: {
                results: undefined
            },
            mensagem: {
                titulo: "",
                mensagem: "",
                html: ""
            },
            disabled: false,
            opcoes: {
                results: [                 
                    {value: 'NULL', label: 'Nenhum'},
                    {value: 'S', label: 'SMS'},
                    {value: 'W', label: 'Whatsapp'}
                ]
            },
            comboNomeCampanhas:
            {
                results: undefined
            },             
            comboNomeCampanhasAutoComplete: [],            
            campanhaValues: {
                value: "",
                label: ""
            },
            loadingCampanha: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.confirmarSaveArquivosFaltantes = this.confirmarSaveArquivosFaltantes.bind(this);
        this.onClickCancelar = this.onClickCancelar.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.LoadComboNomeCampanhas = this.LoadComboNomeCampanhas.bind(this);
    }

    componentDidMount() {
        this.LoadComboEmpresa();
    }

    formInitialState() {

        return {
            file: "",
            empresa: { id: 0 },
            pdfUnificado: false,
            senhaPdf: false,
            naoPossuiAnexo: false,
            opcoes: { value: '' }
        }

    }

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'id_produto': null
        });

        const url = `${c.API_BASE_URL}/company-user`;
        const options = {
            method: 'POST',
            body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    handleChange(e) {
        const form = this.state.form;
        const self = this;

        const { name, checked, value } = e.target;

        if (name === "pdfUnificado" || name === "senhaPdf") {
            if (checked && form.naoPossuiAnexo) {
                form.naoPossuiAnexo = false;
            }
            form[name] = checked;
        }
        else if (name === "naoPossuiAnexo") {
            if (checked && (form.pdfUnificado || form.senhaPdf)) {
                form.pdfUnificado = false;
                form.senhaPdf = false;
            }
            form[name] = checked;
        } else {
            form[name] = value;
        }

        if (e.target.name === "empresa") {
            self.setState({
                ...self.state, form: {
                    ...form,
                    empresa: {
                        id: e.target.value
                    }
                }
            });

            self.LoadComboNomeCampanhas(e.target.value);
        } else if (e.target.name === "pdfUnificado") {
            let checked = e.target.checked;
            this.setState({
                ...this.state,
                form: {
                    ...form,
                    pdfUnificado: checked
                }
            });
        } else if (e.target.name === "senhaPdf") {
            let checked = e.target.checked;
            this.setState({
                ...this.state,
                form: {
                    ...form,
                    senhaPdf: checked
                }
            });
        } else if (e.target.name === "naoPossuiAnexo") {
            let checked = e.target.checked;
            this.setState({
                ...this.state,
                form: {
                    ...form,
                    naoPossuiAnexo: checked
                }
            });
        } else if (e.target.name === "opcoes") {
            this.setState({
                ...this.state, form: {
                    ...this.state.form,
                    opcoes: {
                        value: e.target.value
                    }
                }
            });
        } else {
            this.setState({ form: { ...form, [e.target.name]: e.target.value } });
        }
    }

    onChangeFile(e) {
        const form = this.state.form;

        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (form.file != null && form.file != "") {
            const fileType = form.file.name.split(".")[1];
            if(fileType == "zip" || fileType == "7z"){
                if(form.file.size > 110100480) {
                    document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
                    const file = document.querySelector('.file');
                    file.value = '';
                    this.state.form.file = '';
                    throw (c.TOASTER_ERROR("Tamanho do arquivo não permitido."));
                }
                document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name;
            } else {
                document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
                const file = document.querySelector('.file');
                file.value = '';
                this.state.form.file = '';
                throw (c.TOASTER_ERROR("Formato do arquivo não permitido."));
            }
        } else {
            document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        }
    }

    confirmarSaveArquivosFaltantes() {
        const self = this;
        const state = self.state;
        if (state.mailing.id != undefined && state.mailing.id != 0) {
            self.setState({ ...state, loading: true });
            let url = `${c.API_BASE_URL}/toi-validate/confirmar/${state.mailing.id}`;
            const options = {
                method: 'GET'
            };

            callApi(url, options, (resp) => {
                let isError = false;
                let titulo = "";
                let message = "";

                if (resp.status === 200) {
                    message = resp.message;
                } else {
                    isError = true;
                    message = resp.message;
                    c.TOASTER_ERROR(resp.message);
                }

                if (isError) {
                    titulo = "Mensagens de erro:";
                } else {
                    titulo = "Upload Iniciado - Gentileza acompanhar na funcionalidade \"Status Upload\"";
                }

                self.setState({
                    ...state,
                    loading: false,
                    form: {
                        empresa: { id: 0 },
                        file: "",
                        pdfUnificado: false,
                        senhaPdf: false,
                        naoPossuiAnexo: false,
                        opcoes: {
                            value: ''
                        }
                    },
                    mailing: { id: 0 },
                    file: null,
                    mensagem: {
                        ...state.mensagem,
                        titulo: titulo,
                        mensagem: message,
                        html: ""
                    },
                    disabled: false
                });

            });

        }
    }

    handleSave(e) {
        const self = this;
        const state = self.state;

        e.preventDefault(); if (state.loading) return;
        self.setState({ ...state, loading: true, mensagem: { titulo: "", mensagem: "" } });

        if (this.state.form.file === '') {
            c.TOASTER_ERROR('Favor incluir arquivo.');
            self.setState({ ...state, loading: false });
            return;
        }

        let idEmpresa = this.state.form.empresa.id;

        if (idEmpresa === '' || idEmpresa == 0 || idEmpresa == undefined) {
            c.TOASTER_ERROR('Favor escolher uma empresa.');
            self.setState({ ...state, loading: false });
            return;
        }

        let opcoes = this.state.form.opcoes.value;

        let idCampanha = this.state.campanhaValues === null ? "" : this.state.campanhaValues.value;

        if (opcoes === '' || opcoes == undefined) {
            opcoes = 'NULL';
        }

        let data = new FormData();
        data.append('empresa', idEmpresa);
        data.append('pdfUnificado', state.form.pdfUnificado);
        data.append('senhaPdf', state.form.senhaPdf);
        data.append('naoPossuiAnexo', state.form.naoPossuiAnexo);
        data.append('idCampanha', idCampanha);
        data.append('file', state.file);
        data.append('opcoes', opcoes);
 
        let url = `${c.API_BASE_URL}/toi-validate/mailing`;
        const _token = c.AUTH_HEADER(getToken());
        const options = {
            method: 'POST',
            body: data,
            headers: { 'Authorization': _token }
        };

        fetch(url, options).then(async (response) => {
            response.json().then(resp => {
                let isError = false;
                let isArquivoFaltante = false;
                let titulo = "";
                let message = "";
                let html = "";
                let disabled = false;
                if (resp.status === 200) {
                    if (resp.message != "true") {
                        isArquivoFaltante = true;
                    }
                } else {
                    isError = true;
                    c.TOASTER_ERROR(resp.message);
                }
                const select = document.querySelector('select');
                select.value = "Selecione...";
                document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
                const file = document.querySelector('.file');
                file.value = '';
                if (isError) {
                    titulo = "Mensagens de erro:";
                } else if (isArquivoFaltante) {
                    disabled = true;
                    html = (
                        <>
                            <Column size="auto" className="mx-auto">
                                <Row className="m-0 mb-3">
                                    <span>Confirmar envio da rotina com arquivos faltantes?</span>
                                </Row>
                                <Row className="ml-5px" style={{ justifyContent: "center" }}>
                                    <Button onClick={this.confirmarSaveArquivosFaltantes} disabled={state.loading} className="mx-1">Confirmar</Button>
                                    <Button type="reset" onClick={this.onClickCancelar} disabled={state.loading} className="mx-1 btn-danger">Cancelar</Button>
                                </Row>
                            </Column>
                        </>
                    );
                    titulo = "Arquivos faltantes:";
                } else {
                    titulo = "Upload Iniciado - Gentileza acompanhar na funcionalidade \"Status Upload\"";
                }

                message = resp.message === "true" ? "" : resp.message;

                self.setState({
                    ...state,
                    loading: false,
                    form: {
                        empresa: { id: 0 },
                        file: "",
                        pdfUnificado: false,
                        senhaPdf: false,
                        naoPossuiAnexo: false,
                        opcoes: {
                            value: ''
                        },
                    },
                    campanhaValues: {value: "", label: ""},
                    mailing: { id: resp.id },
                    mensagem: {
                        ...state.mensagem,
                        titulo: titulo,
                        mensagem: message,
                        html: html
                    },
                    disabled: disabled
                });
            });
        });
    }

    getMessage() {
        if (this.state.mensagem.titulo != "") {
            return (
                <>
                    <Row className="mt-5 ml-5px " style={{ justifyContent: "center", }}>
                        <strong>{this.state.mensagem.titulo}</strong>
                    </Row>
                    <Row className="ml-5px " style={{ justifyContent: "center" }}>
                        {this.state.mensagem.mensagem}
                    </Row>
                    <Row className="ml-5px " style={{ justifyContent: "center" }}>
                        {this.state.mensagem.html}
                    </Row>
                </>
            );
        }
    }

    onClickCancelar() {
        const file = document.querySelector('.file');
        file.value = '';
        this.setState({
            ...this.state,
            form: {
                empresa: { id: 0 },
                file: "",
                pdfUnificado: false,
                senhaPdf: false,
                naoPossuiAnexo: false,
                opcoes: {
                    value: ''
                },
            },
            campanhaValues: {value: "", label: ""},
            mensagem: {
                ...this.state.mensagem,
                html: ""
            },
            file: null,
            disabled: false,
            loading: false
        });
    }

    LoadComboNomeCampanhas(empresaId) {
        const self = this;

        const url = `${c.API_BASE_URL}/toi-campanhas-por-empresa/${empresaId}`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };

        self.setState(
            {
                loadingCampanha: true,
                campanhaValues: { value: "", label: "" },
                comboNomeCampanhasAutoComplete: []
            }
        );

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loadingCampanha: false, comboNomeCampanhas: response, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';
        
        if (values) {
            campanhaCombo = values.value;
        }
        
        this.setState({ form: { ...form, 'campanha': campanhaCombo } });
        this.setState({ ...this.state, campanhaValues: values });
    }

    render() {
        const form = this.state.form;
        let isDisabled = this.state.loading || this.state.disabled;
        let isDisabledCampanha = this.state.loading || this.state.disabled || this.state.loadingCampanha;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;  

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row>
                    <Column>
                        <IBox>
                            <Title className="pt-5 text-center">
                                <h2 className="fs-20 fw-600 text-body">Envio de arquivos Zip</h2>

                                <h5 className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: <strong>zip, 7z</strong>.</h5>
                                <p />
                                <h5 className="fs-14 fw-400 text-body">O arquivo de <strong>MAILING</strong> deverá estar no formato <i>.csv</i> ou <i>.txt</i></h5>
                                <br/>
                                <h5 className="fs-14 fw-400 text-body">Tamanho <strong>MÁXIMO</strong> permitido do arquivo: <i>100 MB <strong>ZIP</strong></i> ou <i>100 MB <strong>7z</strong></i></h5>
                                <h5 className="fs-14 fw-400 text-body">O conteúdo do arquivo de <strong>MAILING</strong> deverá ser separado por ponto e vírgula. Ex.: (Montreal; montreal@montreal.com.br)</h5>
                                <p>
                                    <h5 className="fs-14 fw-400 text-body">Os anexos deverão estar no formato <i>.pdf</i></h5>
                                </p>
                            </Title>

                            <Content classNaFfe="p-3 border-0">
                                {/* FORMULÁRIO */}
                                <form>
                                    <Row className="m-0 mb-5">
                                        <Column size="10" className="container mx-auto p-0">
                                            <Row className="mt-5 ml-5px " style={{ justifyContent: "left" }}>
                                                <Column size="2" className="px-1 mb-0">
                                                    <label for="empresa">Empresa:</label>
                                                    <Select disabled={isDisabled} name="empresa" className="empresa-carimbo-tempo" selected={form.empresa.id} data={this.state.comboEmpresa} onChange={this.handleChange} placeholder="Empresa" />
                                                </Column>
                                                <TemPermissao permissao={ROLE_ADMINISTRADOR}>
                                                    <Column size="2" className="px-1 mb-0">
                                                        <label for="opcoes">Envio via Celular:</label>
                                                        <Select disabled={isDisabled} name="opcoes" className="" selected={form.opcoes.value} data={this.state.opcoes} onChange={this.handleChange} placeholder="Envio via Celular" />
                                                    </Column>
                                                </TemPermissao>
                                                <TemPermissao permissao={ROLE_FEATURE_1}>
                                                    <Column size="8" className="px-1">
                                                        <div className="form-group col-md-6">
                                                            <label>Rotina:</label>     
                                                            <Autocomplete
                                                                id="combo-campanha"
                                                                options={campanhas}
                                                                getOptionLabel={(option) => option.label}
                                                                style={{marginTop:-8}}
                                                                onChange={this.onNomeCampanhaChange}
                                                                disabled={isDisabledCampanha}
                                                                value={this.state.campanhaValues}
                                                                getOptionSelected={(option) => option.value}
                                                                renderInput={
                                                                    (params) => 
                                                                    <TextField 
                                                                        {...params} 
                                                                        variant="outlined"  
                                                                        margin="dense"
                                                                    /> 
                                                                }
                                                            /> 
                                                        </div>
                                                    </Column>
                                                </TemPermissao>
                                            </Row>
                                            <Row className="ml-5px " style={{ justifyContent: "left" }}>
                                                <Column size="11" className="px-1">
                                                    <input disabled={isDisabled} type="file" name="file" className="custom-file-input file" id="validatedCustomFile" required onChange={this.onChangeFile} />
                                                    <label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
                                                </Column>
                                            </Row>
                                            <Row className="ml-5px " style={{ justifyContent: "left" }}>
                                                <TemPermissao permissao={ROLE_FEATURE_3}>
                                                    <Column size="3" className="px-1">                                                    
                                                        <input placeholder='pdf unificado'
                                                            type='checkbox'
                                                            className='form-check-input'
                                                            name="pdfUnificado"
                                                            onChange={this.handleChange} checked={form.pdfUnificado}
                                                            style={{marginLeft: 0}}
                                                        />
                                                        <label for="pdfUnificado" className='form-check-label' style={{marginLeft: "1.25rem"}}>Anexos contidos em um único arquivo PDF?</label>	
                                                    </Column>
                                                </TemPermissao>
                                                <Column size="3" className="px-1">                                                    
                                                    <input placeholder='pdf com senha'
                                                        type='checkbox'
                                                        className='form-check-input'
                                                        name="senhaPdf"
                                                        onChange={this.handleChange} checked={form.senhaPdf}
                                                        style={{marginLeft: 0}}
                                                    />
                                                    <label for="senhaPdf" className='form-check-label' style={{marginLeft: "1.25rem"}}>PDF sem Senha?</label>	
                                                </Column>
                                                <Column size="3" className="px-1">                                                    
                                                    <input placeholder='mailing sem anexo'
                                                        type='checkbox'
                                                        className='form-check-input'
                                                        name="naoPossuiAnexo"
                                                        onChange={this.handleChange} checked={form.naoPossuiAnexo}
                                                        style={{marginLeft: 0}}
                                                    />
                                                    <label for="naoPossuiAnexo" className='form-check-label' style={{marginLeft: "1.25rem"}}>Mailing deverá ser enviado sem Anexos?</label>	
                                                </Column>
                                            </Row>
                                        </Column>
                                    </Row>

                                    {/* NAVEGAÇÃO */}
                                    <Row className="m-0 mb-3">
                                        <Column size="auto" className="mx-auto">
                                            <div className="input-group">

                                                <Button onClick={this.handleSave} disabled={isDisabled} className="mx-1" width="130px">Salvar</Button>

                                                <div className="ml-4">
                                                    {this.state.loading && (
                                                        <CircularProgress
                                                            size={30}
                                                            thickness={4}
                                                            color='inherit'
                                                            variant='indeterminate' />
                                                    )}
                                                </div>
                                            </div>
                                        </Column>
                                    </Row>
                                    {this.getMessage()}
                                </form>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch) {
    return { actions: { lista: bindActionCreators(dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioToi));
